import { ComponentIds } from '@inter-ikea-core/core';
/**
 * @param {Entity} entity - an entity
 * @returns {boolean} true if the entity has a Product Part Component and false otherwise
 */
export const hasProductPartComponent = (entity) => entity.hasComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID);
/**
 * @param {Entity} entity - an entity
 * @returns {ProductPartComponent | null} the Product Part Component for the entity if it exists (or null)
 */
export const getProductPartComponent = (entity) => entity.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID) ?? null;
/**
 * @param {Entity} entity - an entity
 * @returns {string | null} product part key for the given entity according to the corresponding Product Part Component if it exists (or null)
 */
export const getProductPartKey = (entity) => getProductPartComponent(entity)?.partKey ?? null;
//# sourceMappingURL=product-part-entity-utils.js.map